import React, { useState, useRef, useEffect } from 'react'
import Button from '@mui/material/Button';
import api from "../../controller/api"
import { toast, Toaster } from 'sonner';
import { BiLoader } from "react-icons/bi"

export default function ChangePassword() {
    const [oldPassword, setOldPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmNewPassword, setConfirmNewPassword] = useState("")
    const [loading, setLoading] = useState(false)

    const handleChangePassword = async (e) => {
        e.preventDefault()
        setLoading(true)

        try {
            const data = {
                currentPassword: oldPassword,
                newPassword: newPassword,
                confirmNewPassword: confirmNewPassword
            }
            await api.put("/user/changePassword", data)
            toast.success("Password changed successfully")
            setOldPassword("")
            setNewPassword("")
            setConfirmNewPassword("")
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className='manage'>
            <h2 style={{ display: "flex", justifyContent: "space-between" }}>
                Change Password
            </h2>
            <form className='add-product' onSubmit={handleChangePassword}>
                <Toaster richColors position="top-center" />
                <div className='form-row'>
                    <div className='inpt-row'>
                        <label>Old Password</label>
                        <input type='password' value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} required />
                    </div>
                </div>
                <div className='form-row'>
                    <div className='inpt-row'>
                        <label>New Password</label>
                        <input type='password' value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                    </div>
                </div>
                <div className='form-row'>
                    <div className='inpt-row'>
                        <label>Confirm New Password</label>
                        <input type='password' value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} required />
                    </div>
                </div>
                <Button type='submit' variant="contained" disableElevation>
                    {loading ? <BiLoader size={24} className='animate-spin' /> : "Change Password"}
                </Button>
            </form>
        </div>

    )
}
